import { browser, os, fingerPrintHash } from '@/helpers/BrowserHelpers'

/**
 * Device Vuex Module.
 */
export default {
    namespaced: true,
    state: {
        identifier: null,
        name: null,
        type: null,
        version: null,
    },
    actions: {
        /**
         * identify user's device
         *
         * @param {Object} Vuex
         *
         * @returns {void}
         */
        async identifyDevice({ commit, state }) {
            const hash = await fingerPrintHash()

            if (state.identifier === null) {
                commit('type', os())
                commit('identifier', `${os().replace(' ', '_')}_${browser()}_${hash}`)
                commit('name', `${os()} (${browser()})`)
            }
        },

        /**
         * Set user's device information
         *
         * @param {Object} Vuex
         * @param {Object} device
         *
         * @returns {void}
         */
        set({ commit }, device) {
            commit('type', device.device_type)
            commit('identifier', device.device_identifier)
            commit('name', device.device_name ?? device.device_identifier)
            commit('version', device.device_version ?? null)
        },
    },
    mutations: {
        /**
         * Update state identifier.
         *
         * @param {Object} state
         * @param {String} identifier
         *
         * @returns {void}
         */
        identifier(state, identifier) {
            state.identifier = identifier
        },

        /**
         * Update state name.
         *
         * @param {Object} state
         * @param {String} name
         *
         * @returns {void}
         */
        name(state, name) {
            state.name = name
        },

        /**
         * Update state type.
         *
         * @param {Object} state
         * @param {String} type
         *
         * @returns {void}
         */
        type(state, type) {
            state.type = type
        },

        /**
         * Update state version.
         *
         * @param {Object}      state
         * @param {String|null} version
         *
         * @returns {void}
         */
        version(state, version) {
            state.version = version
        },
    },
    getters: {
        /**
         * Get user device details.
         *
         * @param {Object} state
         *
         * @returns {Object}
         */
        getDevice(state) {
            return state
        },
    },
}
